import { SkillItem } from "../props/interface";

function Skill(item: SkillItem) {
  return (
    <div className="mb-4 mr-4 w-[265px] rounded-lg border border-[#6e89bb] bg-white p-[18px_3px_10px_12px]">
      <p
        className="font-[Inter]"
        style={{
          fontSize: "15px",
          color: "#0000004d",
        }}
      >
        {item.title}
      </p>
      <p
        className="font-[Inter]"
        style={{
          fontSize: "14px",
          color: "#000000",
        }}
      >
        {item.skills}
      </p>
    </div>
  );
}

export default Skill;
